import { IActionContext } from '@msdyn365-commerce/core-internal';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { SyntheticEvent } from 'react';

export const GetWebGroupImage = (context: IActionContext, id: string | undefined): string => {
    return generateImageUrl(`Products/wg_${id}.png`, context.requestContext.apiSettings) || '';
};
export const GetCategoryImage = (context: IActionContext, id: string): string => {
    return generateImageUrl(`Categories/${id}.png`, context.requestContext.apiSettings) || '';
};
export const SetFallbackImage = (evt: SyntheticEvent<HTMLImageElement>): void => {
    // evt.currentTarget.src = 'https://files-us-prod.cms.commerce.dynamics.com/cms/api/cjqrlxggbf/binary/MA5hPa';
    evt.currentTarget.src =
        'https://images-us-prod.cms.commerce.dynamics.com/cms/api/cjqrlxggbf/imageFileData/search?fileName=placeholder.jpg';
};
